import React, { useEffect, useState } from 'react'
import { env, netsuite_url, wms_uploads_cdn } from '../config';
import { Checkbox, Col, Divider, Flex, Modal, Row, Select, Table, Tag, Tooltip, Typography, Input, Image, Button, Alert } from 'antd';
import { deliveryStatuses } from '../common/Constants';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import AuthService from '../auth/AuthService';
import { showMessage } from '../Utils/message';
import { CloseOutlined, DeleteFilled, ExportOutlined, InfoCircleOutlined, NumberOutlined } from '@ant-design/icons';
import ProductScanSelect from '../../pages/Scan/ProductScanSelect';
import { Button as UploadButton } from '@mui/material';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import DetailsGrid from '../common/DetailsGrid';
import { getUploadUrl, handleDeleteCurrentFile, handleDeleteFile, handleSubmitImage, uploadFileToS3 } from '../common/CommonFun';

const Auth = new AuthService();

const GoodsReturnTab = ({ routeReturnData, setRouteReturnData, selectedRoute, handleCloseDrawer }) => {
    const layoutDispatch = useLoadingDispatch();
    const { Option } = Select;
    const { Text } = Typography;
    const { TextArea } = Input;
    const { products } = useSelector((state) => state?.AppState?.userCreds);
    const [itemBatches, setItemBatches] = React.useState([]);
    const [stockTransactions, setStockTransactions] = React.useState([]);
    const [selectedItem, setSelectedItem] = React.useState(null);
    const [modalVisible, setModalVisible] = React.useState(false);

    const [notes, setNotes] = useState("");
    const [files, setFiles] = useState([]);
    const [currentItemFiles, setCurrentItemFiles] = useState([]);
    const [deletedFiles, setDeletedFiles] = React.useState([]);
    const [returnedStock, setReturnedStock] = useState({
        product_id: null,
        item_pallet_id: '',
        quantity: "",
        expiry_date: null,
        batch_id: null,
        batch_code: '',
        supplier_batch_code: '',
        purchase_order_details_batch_id: '',
        remaining_item_batch_quantity: '',
        remaining_quantity_check: false,
        full_pallet_check: false,
        show_remain: false,
        show_full: false
    });

    useEffect(() => {
     setNotes(selectedRoute?.route_returned_notes)
    setCurrentItemFiles(selectedRoute?.route_returned_files ? JSON.parse(selectedRoute?.route_returned_files) : [])
    }, [selectedRoute])
    

    const submitImage = (e) => {
        e.persist?.();
        handleSubmitImage(e, setFiles, setCurrentItemFiles)
    }

    const productSelectValueChange = (val, isScanned) => {
        console.log('productSelectValueChange', val, isScanned);

        if (isScanned) {
            const selectedProduct = products?.find((pro) => pro?.code == val || pro?.barcode == val);
            const matchedProduct = selectedItem?.item_internal_id == selectedProduct?.netsuite_id ? true : false;
            if (selectedProduct && matchedProduct) {
                setReturnedStock({ ...returnedStock, product_id: selectedProduct?.netsuite_id, item_pallet_id: selectedItem?.item_pallet_id, quantity: '', });
            } else {
                setReturnedStock({ ...returnedStock, product_id: null, item_pallet_id: '', quantity: '', });
                showMessage('error', 'Invalid product selected')
            }

        } else {
            const selectedProduct = products?.find((pro) => pro?.netsuite_id == val);
            const matchedProduct = selectedItem?.item_internal_id == selectedProduct?.netsuite_id ? true : false;
            if (selectedProduct && matchedProduct) {
                setReturnedStock({ ...returnedStock, product_id: val, item_pallet_id: selectedItem?.item_pallet_id, quantity: '', });
            } else {
                setReturnedStock({ ...returnedStock, product_id: null, item_pallet_id: '', quantity: '', });
                showMessage('error', 'Invalid product selected')
            }
        }
    };

    const saveData = async () => {
        if(currentItemFiles?.length < 1) return showMessage('error', 'Add at least one image')
        showLoading(layoutDispatch);
        const dataToSend = {
            route_status_id: selectedRoute?.id,
            route_returned_notes: notes,
            route_returned_files: currentItemFiles ? currentItemFiles : [],
        }
        try {
            const res = await Auth.fetch(`/route/update-route-returns`, {
                method: "POST",
                body: JSON.stringify(dataToSend)
            });
            if (res?.ack) {
                showMessage('success', res?.message);

                const uploadPromises = []
                if (files.length > 0) {
                    files.forEach((f) => {
                        uploadPromises.push(
                            getUploadUrl(f, 'route-returns', selectedRoute?.id)
                                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                                .catch(error => console.error("Error uploading file:", error))
                        );
                    });
                }
                await Promise.all(uploadPromises);
                handleCloseDrawer()
            } else {
                showMessage('error', res?.message);
            }

        } catch (err) {
            console.log(err);
            showMessage('error', 'Something went wrong');

        }
        finally {
            hideLoading(layoutDispatch);
        }
    };

    const handleSelect = async (record) => {
        showLoading(layoutDispatch)
        try {
            const response = await Auth.fetch(`/route/route-packing-batches-returns?route_status_id=${routeReturnData[0]?.route_status_id}`);
            if (response?.ack) {
                const data = response?.route_batches || [];
                const filteredData = data.filter(item => item?.item_pallet_id == record?.item_pallet_id)
                console.log(filteredData, 'filteredData');

                try {
                    const res = await Auth.fetch(`/route/route-packing-batches?item_pallet_id=${record?.item_pallet_id}`);

                    if (res?.ack) {
                        let batches = res?.route_batches || [];

                        if (filteredData.length > 0) {
                            // step 1: group filteredData by item_pallet_id + id
                            const grouped = filteredData.reduce((acc, fd) => {
                                const key = `${fd.item_pallet_id}_${fd.purchase_order_details_batch_id}_${fd?.wms_pallet_builder_order_items_batch_id}`;
                                acc[key] = (acc[key] || 0) + (fd?.quantity || 0);
                                return acc;
                            }, {});

                            // step 2: subtract total grouped quantity from batches
                            batches = batches.map(batch => {
                                const key = `${batch.item_pallet_id}_${batch.purchase_order_details_batch_id}_${batch.id}`;
                                const deductedQty = grouped[key] || 0;
                                const remainingQty = (batch?.quantity || 0) - deductedQty;

                                return {
                                    ...batch,
                                    remaining_batch_quantity: remainingQty
                                };
                            });
                        } else {
                            // no filtered data, so remaining = original
                            batches = batches.map(batch => ({
                                ...batch,
                                remaining_batch_quantity: batch?.quantity
                            }));
                        }
                        setItemBatches(batches)
                        setStockTransactions(filteredData)
                        setSelectedItem(record)
                        setModalVisible(true)
                    } else {
                        showMessage('error', res?.message)
                        setStockTransactions([])
                    }
                } catch (err) {
                    showMessage('error', 'Something went wrong while fetching packing transactions')
                }

            }
        } catch (err) {
            console.log(err);
            showMessage('error', 'something went wrong')
        } finally {
            hideLoading(layoutDispatch)
        }
    };

    const handleDeleteItemTransaction = async (record) => {
        const payload = {
            id: record?.id,
        }
        showLoading(layoutDispatch)
        console.log(payload);
        try {
            const res = await Auth.fetch('/route/route-packing-batch-return', {
                method: 'DELETE',
                body: JSON.stringify(payload)
            })
            if (res?.ack) {
                showMessage('success', res?.message)
                setModalVisible(false)

                setRouteReturnData((prev) =>
                    prev.map((item) => {
                        if (item.item_pallet_id === record.item_pallet_id) {
                            const newRemaining = Math.max(
                                0,
                                (item.remaining_quantity_returned || 0) + Number(record.quantity)
                            );

                            return {
                                ...item,
                                remaining_quantity_returned: newRemaining,
                                returned_quantity:
                                    (Number(item.returned_quantity) || 0) - Number(record.quantity),
                            };
                        }
                        return item;
                    })
                );

                setReturnedStock({
                    product_id: null,
                    quantity: "",
                    expiry_date: null,
                    batch_id: null,
                    batch_code: '',
                    supplier_batch_code: '',
                    purchase_order_details_batch_id: '',
                    item_pallet_id: null,
                });
            } else {
                showMessage('error', res?.message);
            }
        } catch (err) {
            showMessage('error', 'something went wrong');
        } finally {
            hideLoading(layoutDispatch)
        }
    };

    const handleOkModal = async () => {
        if(!returnedStock?.product_id) return showMessage('error', 'Select product a product');
        if(returnedStock?.batch_id < 1) return showMessage('error', 'Select a item batch');
            if(!returnedStock?.quantity || returnedStock?.quantity < 1) return showMessage('error', 'Enter a valid quantity');
        const payload = {
            delivery_date: routeReturnData[0]?.delivery_date,
            route_status_id: routeReturnData[0]?.route_status_id,
            route_code: selectedRoute?.code,
            route_name: selectedRoute?.title,
            pallet_builder_id: selectedItem?.pallet_builder_id,
            pallet_number: '',
            item_pallet_id: selectedItem?.item_pallet_id,
            product_netsuite_id: selectedItem?.item_internal_id,
            quantity: returnedStock?.quantity,
            purchase_order_details_batch_id: returnedStock?.purchase_order_details_batch_id,
            batch_code: returnedStock?.batch_code,
            supplier_batch_code: returnedStock?.supplier_batch_code,
            internal_id: selectedItem?.internal_id,
            sale_order_no: selectedItem?.sale_order_no,
            inv_internal_id: selectedItem?.inv_internal_id,
            invoice_no: selectedItem?.invoice_no,
            customer_code: selectedItem?.customer_name,
            customer_name: selectedItem?.customer_project_id,
            id: returnedStock?.batch_id,
            expiry_date: returnedStock?.batch_expiry,

        }
        console.log(payload);

        showLoading(layoutDispatch)
        console.log(payload);
        try {
            const res = await Auth.fetch('/route/route-packing-batch-returns', {
                method: 'PUT',
                body: JSON.stringify(payload)
            })
            if (res?.ack) {
                showMessage('success', res?.message)
                setModalVisible(false)

                setRouteReturnData((prev) =>
                    prev.map((item) => {
                        if (item.item_pallet_id === selectedItem.item_pallet_id) {
                            const newRemaining = Math.max(
                                0,
                                (item.remaining_quantity_returned || 0) - Number(returnedStock.quantity)
                            );

                            return {
                                ...item,
                                remaining_quantity_returned: newRemaining,
                                returned_quantity:
                                    (Number(item.returned_quantity) || 0) + Number(returnedStock.quantity),
                            };
                        }
                        return item;
                    })
                );

                setReturnedStock({
                    product_id: null,
                    quantity: "",
                    expiry_date: null,
                    batch_id: null,
                    batch_code: '',
                    supplier_batch_code: '',
                    purchase_order_details_batch_id: '',
                    item_pallet_id: null,
                });
            } else {
                showMessage('error', res?.message);
            }
        } catch (err) {
            showMessage('error', 'something went wrong');
        } finally {
            hideLoading(layoutDispatch)
        }
    }

    const handleModalCancel = () => {
        setReturnedStock({
            product_id: null,
            quantity: "",
            expiry_date: null,
            batch_id: null,
            batch_code: '',
            supplier_batch_code: '',
            purchase_order_details_batch_id: '',
            item_pallet_id: ''
        });
        setModalVisible(false);
    };

    const dataCol = [
        {
            title: "Shop Code",
            render: (text, record) => {
                return (
                    <span>
                        <a
                            href={`${netsuite_url}/app/common/entity/custjob.nl?id=${record.customer_internal_id}`}
                            target="_blank"
                        >
                            {record.customer_name}
                        </a>
                    </span>
                );
            },
        },
        {
            title: "Shop Name",
            dataIndex: "customer_project_id",
            key: "customer_project_id",
        },

        {
            title: 'Order',
            render: (text, record) => {
                return (
                    <span>

                        <a
                            href={`${netsuite_url}/app/accounting/transactions/salesord.nl?id=${record?.internal_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {record?.sale_order_no}
                        </a>
                    </span>
                );
            },
        },
        {
            title: 'Invoice',
            render: (text, record) => {
                return (
                    <span>
                        <a
                            href={`${netsuite_url}/app/accounting/transactions/custinvc.nl?id=${record?.invoice_internal_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {record?.invoice_no}
                        </a>

                    </span>
                );
            },
        },


        {
            title: "Item Code",
            dataIndex: "item_id",
            key: "item_id",
        },
        {
            title: "Item Name",
            dataIndex: "item_name",
            key: "item_name",
        },
        {
            title: "Ordered Qty",
            dataIndex: "quantity",
            key: "quantity",
            align: "center",
        },
        {
            title: "Packed Qty",
            align: "center",
            render(record) {
                return <span>{record?.packed_quantity || 0}</span>
            },
        },
        {
            title: "Delivered Qty",
            align: "center",
            render(record) {
                return <span>{record?.delivered_quantity || 0}</span>
            },
        },
        {
            title: "Returned Qty",
            align: "center",
            render(record) {
                return <Tag color={record?.returnedQty > 0 ? 'red' : 'green'}>{record?.returnedQty}</Tag>
            },
        },
        {
            title: "Warehouse Received Qty",
            align: "center",
            render(record) {
                return <>{record?.returned_quantity || 0}</>
            },
        },
        {
            title: "Remaining Quantity",
            render(record) {
                return <Tag color={record?.remaining_quantity_returned > 0 ? 'red' : 'green'}>{record?.remaining_quantity_returned}</Tag>
            },
            align: "center",
        },
        {
            title: "Reason",
            render(record) {
                const status = deliveryStatuses.find(status => status.id === record?.delivery_status)
                return <>{record?.delivery_status ? status?.title : ''}</>
            },
        },
        {
            title: "Action",
            align: "center",
            render: (record) => (
                <Tooltip title="Select Item">
                    <ExportOutlined
                        className="animated-select-icon"
                        onClick={() => {
                            // if (selectedRoute?.route_returned_by < 1) return showMessage('error', 'Route is not returned yet.')
                            if (record?.packed_quantity < 1) return showMessage('error', 'No transactions found for this item.')
                            handleSelect(record)
                        }}
                    />
                </Tooltip>
            ),
        }
    ];

    const transactionCol = [


        {
            title: 'Batch Code',
            dataIndex: 'batch_code',
            key: 'batch_code',
        },
        {
            title: 'Supplier Batch Code',
            dataIndex: 'supplier_batch_code',
            key: 'supplier_batch_code',
        },


        {
            title: "Quantity",
            render(record) {
                return (
                    <Flex gap={5} align="center">
                        <span>{record?.quantity?.toLocaleString() || '0'}</span>
                    </Flex>
                )
            }
        },
        // {
        //     title: "Expiry",
        //     render(record) {
        //         return (
        //             <Flex gap={5} align="center">
        //                 <span>{record?.expiry_date ? dayjs(record?.expiry_date).format('DD-MM-YYYY') : null}</span>
        //             </Flex>
        //         )
        //     }
        // },
        {
              title: "Expiry",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{record?.expiry_date}</Tag>;
              }
            },

        {
            title: "Created At",
            render(record) {
                return (
                    <Flex gap={5} align="center">
                        <span>{record?.createdAt ? dayjs(record?.createdAt).format('DD-MM-YYYY HH:mm:ss') : null}</span>
                    </Flex>
                )
            }
        },
        {
              title: "User",
              render(record) {
                if (!record) return "";
        
                const user = record?.user_name || "";
                const helper = record?.helper_name || "";
        
                if (helper) {
                  return (
                    <>
                      {helper}{" "}
                      {user && (
                        <Tooltip title={`${user}`}>
                          <InfoCircleOutlined style={{ fontSize: 16, marginLeft: 6, color: "#1890ff" }} />
                        </Tooltip>
                      )}
                    </>
                  );
                }
        
                return <>{user}</>;
              }
            },
        
        // {
        //     title: "Action",
        //     align: "center",
        //     render: (record) => (
        //         <Tooltip title="Delete Transaction">
        //             <DeleteFilled style={{ color: 'red', fontSize: 22 }} onClick={() => handleDeleteItemTransaction(record)} />
        //         </Tooltip>
        //     ),
        // }
    ];

    if(!selectedRoute?.route_returned_by > 0){
        transactionCol.push({
            title: "Action",
            align: "center",
            render: (record) => (
                <Tooltip title="Delete Transaction">
                    <DeleteFilled style={{ color: 'red', fontSize: 22 }} 
                    onClick={() => {
                        // handleDeleteItemTransaction(record)
                        Modal.confirm({
                                                  title: 'Delete Transaction',
                                                  centered: true,
                                                  content: `Are you sure you want to delete this transaction?`,
                                                  onOk: () => handleDeleteItemTransaction(record),
                                                  okText: 'Delete',
                                                  cancelText: 'Cancel',
                                                  width: 600,
                                                  okButtonProps: { size: "large" },
                                                  cancelButtonProps: { size: "large" },
                                              });
                    }}
                     />
                </Tooltip>
            ),
        })
    }

    const infoItem = [
        { label: 'Total Quantity', value: selectedItem?.returnedQty?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#1677ff" }} /> },
        { label: 'Remaining Quantity', value: selectedItem?.remaining_quantity_returned?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#1677ff" }} /> },
    ];

    return (
        <div>
            <Table
                style={{ marginTop: "10px" }}
                columns={dataCol}
                dataSource={routeReturnData}
                pagination={false}
                scroll={{ x: 'max-content' }}
                rowClassName={(record) => (record?.packed_quantity < 1 ? "highlight-row" : "")}

            />

            <>
                <Row style={{ marginTop: '15px' }} gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                        <span>
                            Notes:
                        </span>
                        <TextArea
                            value={notes}
                            onChange={(e) => { setNotes(e.target.value) }}
                            placeholder='Notes.'
                            autoSize={{ minRows: 3, maxRows: 6 }}
                            style={{
                                  borderColor: selectedRoute?.route_returned_by > 0 ? '#1890ff' : undefined,
                                  backgroundColor: selectedRoute?.route_returned_by > 0 ? '#e6f7ff' : undefined,
                                  borderWidth: selectedRoute?.route_returned_by > 0 ? '2px' : undefined,
                            }}
                        />

                    </Col>
                </Row>
                <div>
                    <UploadButton
                        component="label"
                        variant="contained"
                        sx={{ marginTop: "10px" }}
                        startIcon={<CloudUploadIcon />}
                    >
                        Add files
                        <input
                            type="file"
                            hidden
                            multiple
                            capture
                            accept="image/*, video/*"
                            onClick={(e) => {
                        // ensures it always triggers even if same file is picked
                        e.target.value = "";
                    }}
                            onChange={(e) => {
                                const myfiles = e.target.files;

                                if (myfiles.length > 10) {
                                    showMessage('error', "A maximum of 10 images can be uploaded at a time.");
                                    e.target.value = "";
                                } else {
                                    submitImage(e);
                                }
                            }}
                        />
                    </UploadButton>
                </div>

                {currentItemFiles?.length > 0 && <h4>Current Files:</h4>}
                <Image.PreviewGroup>
                    {currentItemFiles?.length > 0 &&
                        currentItemFiles
                            .filter((item) => !files.some((file) => file.name === item))
                            .map((item) => {
                                const encodedFileName = item.replace(/\+/g, '%2B');
                                const imageUrl = `${wms_uploads_cdn}/${env}/route-returns/${selectedRoute?.id}/${encodedFileName}`;
                                return (
                                    <div
                                        style={{
                                            position: "relative",
                                            marginRight: "10px",
                                            display: "inline-block",
                                        }}
                                    >
                                        <Image
                                            width={200}
                                            height={150}
                                            style={{ padding: "5px", border: "1px solid lightgrey" }}
                                            src={imageUrl}
                                        />
                                        <Tooltip title="Delete">
                                            <CloseOutlined
                                                style={{
                                                    fontSize: "30px",
                                                    position: "absolute",
                                                    right: 5,
                                                    top: 5,
                                                    color: "#c12828",
                                                }}
                                                onClick={() => {
                                                    handleDeleteCurrentFile(item, deletedFiles, setDeletedFiles, currentItemFiles, setCurrentItemFiles)
                                                }
                                                }
                                            />
                                        </Tooltip>
                                    </div>
                                );
                            })}
                </Image.PreviewGroup>

                {files?.length > 0 && <Divider />}

                {files?.length > 0 && <h4>Files:</h4>}
                <Image.PreviewGroup>
                    {files?.length > 0 &&
                        files.map((item) => {
                            return (
                                <div
                                    style={{
                                        position: "relative",
                                        marginRight: "10px",
                                        display: "inline-block",
                                    }}
                                >
                                    <Image
                                        width={200}
                                        height={150}
                                        style={{ padding: "5px", border: "1px solid lightgrey" }}
                                        src={URL.createObjectURL(item?.file)}
                                    />
                                    <Tooltip title="Delete">
                                        <CloseOutlined
                                            style={{
                                                fontSize: "30px",
                                                position: "absolute",
                                                right: 5,
                                                top: 5,
                                                color: "#c12828",
                                            }}
                                            onClick={() => {
                                                handleDeleteFile(item?.name, files, currentItemFiles, setFiles, setCurrentItemFiles)
                                            }}
                                        />
                                    </Tooltip>
                                </div>
                            );
                        })}
                </Image.PreviewGroup>

                <Flex justify='end'>
                    <Button  type='primary' style={{ marginRight: 5}}  onClick={() => {
                        Modal.confirm({
                            title: 'Save goods Return',
                            centered: true,
                            // content: `Are you sure to save goods return for this route?. Ypu wont be able to chnage it again`,
                            content: `Are you sure you want to save the goods return for this route? You won't be able to change it afterwards.`,
                            onOk: () => saveData(),
                            okText: 'Save',
                            width: 600,
                            okButtonProps: { size: "large" },
                            cancelButtonProps: { size: "large" },
                        });
                    }}>Save Goods Return</Button>
                </Flex>
            </>

            <Modal width={'70vw'} title={` Goods Returned: ${selectedItem?.item_id} - ${selectedItem?.item_name}`}
                open={modalVisible}
                onOk={handleOkModal}
                onCancel={handleModalCancel}
                okText='Save'
                okButtonProps={ { style: { display: 'none'}}}
                cancelButtonProps={ { style: { display: (selectedRoute?.route_returned_by < 1 || selectedItem?.remaining_item_batch_quantity > 0) && 'none'}}}
            >
                <Divider style={{ margin: '10px 0' }} />
                <>
                    <DetailsGrid infoItems={infoItem} />
                    {
                        (selectedItem?.remaining_quantity_returned > 0 && selectedRoute?.route_returned_by < 1) ? (
                            <>
                                <Row style={{ marginBottom: "10px" }}>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Text>Product</Text>
                                        <ProductScanSelect
                                            onValueChange={productSelectValueChange}
                                            value={returnedStock?.product_id}
                                            options={products} placeholder="Product"
                                            size="large"
                                            length={'100%'}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Text>Item Batches</Text>
                                        <Select
                                            placeholder="Item Batches"
                                            size="large"
                                            showSearch
                                            style={{ width: '100%' }}
                                            filterOption={(input, option) =>
                                                option?.label?.props?.children
                                                    ?.map?.((el) => (typeof el === 'string' ? el : ''))
                                                    .join(' ')
                                                    .toLowerCase()
                                                    .includes(input.toLowerCase())
                                            }
                                            value={returnedStock?.batch_id}
                                            onChange={(value) => {
                                                const remainingTotal = selectedItem?.remaining_quantity_returned;
                                                const remainingBatch = itemBatches?.find((item) => item?.id == value)?.remaining_batch_quantity || 0;
                                                const selectedProduct = products?.find((pro) => pro?.netsuite_id == selectedItem?.item_internal_id);
                                                const fullPalletQty = selectedProduct?.cases_in_pallets;
                                                if(remainingBatch > remainingTotal ) {
                                                 if(remainingBatch > fullPalletQty) {
                                                    setReturnedStock({
                                                    ...returnedStock,
                                                    batch_id: value,
                                                    remaining_item_batch_quantity: remainingBatch,
                                                    batch_quantity: itemBatches?.find((item) => item?.id == value)?.quantity || 0,
                                                    batch_expiry: itemBatches?.find((item) => item?.id == value)?.expiry_date,
                                                    supplier_batch_code: itemBatches?.find((item) => item?.id == value)?.supplier_batch_code,
                                                    batch_code: itemBatches?.find((item) => item?.id == value)?.batch_code,
                                                    purchase_order_details_batch_id: itemBatches?.find((item) => item?.id == value)?.purchase_order_details_batch_id,
                                                    show_full: true, 
                                                    show_remain: false
                                                });
                                                 }   else  {
                                                    setReturnedStock({
                                                    ...returnedStock,
                                                    batch_id: value,
                                                    remaining_item_batch_quantity: remainingBatch,
                                                    batch_quantity: itemBatches?.find((item) => item?.id == value)?.quantity || 0,
                                                    batch_expiry: itemBatches?.find((item) => item?.id == value)?.expiry_date,
                                                    supplier_batch_code: itemBatches?.find((item) => item?.id == value)?.supplier_batch_code,
                                                    batch_code: itemBatches?.find((item) => item?.id == value)?.batch_code,
                                                    purchase_order_details_batch_id: itemBatches?.find((item) => item?.id == value)?.purchase_order_details_batch_id,
                                                    show_full: false, 
                                                    show_remain: true
                                                });
                                                 }
                                                } else {
                                                    setReturnedStock({
                                                    ...returnedStock,
                                                    batch_id: value,
                                                    remaining_item_batch_quantity: remainingBatch,
                                                    batch_quantity: itemBatches?.find((item) => item?.id == value)?.quantity || 0,
                                                    batch_expiry: itemBatches?.find((item) => item?.id == value)?.expiry_date,
                                                    supplier_batch_code: itemBatches?.find((item) => item?.id == value)?.supplier_batch_code,
                                                    batch_code: itemBatches?.find((item) => item?.id == value)?.batch_code,
                                                    purchase_order_details_batch_id: itemBatches?.find((item) => item?.id == value)?.purchase_order_details_batch_id,
                                                    show_full: false, 
                                                    show_remain: false
                                                });
                                                }

                                                
                                                // setReturnedStock({
                                                //     ...returnedStock,
                                                //     batch_id: value,
                                                //     remaining_item_batch_quantity: remainingBatch,
                                                //     batch_quantity: itemBatches?.find((item) => item?.id == value)?.quantity || 0,
                                                //     supplier_batch_code: itemBatches?.find((item) => item?.id == value)?.supplier_batch_code,
                                                //     batch_code: itemBatches?.find((item) => item?.id == value)?.batch_code,
                                                //     purchase_order_details_batch_id: itemBatches?.find((item) => item?.id == value)?.purchase_order_details_batch_id
                                                // });
                                            }}
                                            optionLabelProp="label"
                                        >
                                            {itemBatches.map((item) => {
                                                const label = (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        <>
                                                            <Tag color="blue" style={{ margin: 0 }}>Qty: {item?.quantity}</Tag>
                                                            <Tag color="blue" style={{ margin: 0 }}>Remaining Qty: {item?.remaining_batch_quantity}</Tag>
                                                        </>
                                                        <Tag color='blue' style={{ margin: 0 }}>
                                                            Code: {item?.supplier_batch_code ? item?.supplier_batch_code : 'N/A'}
                                                        </Tag>
                                                    </div>
                                                );

                                                return (
                                                    <Option key={item.id} value={item.id} label={label} style={{ padding: 0 }}>
                                                        <div
                                                            style={{
                                                                padding: '8px 12px',
                                                                margin: '4px 0',
                                                                border: '1px solid #f0f0f0',
                                                                borderRadius: '8px',
                                                                backgroundColor: '#fafafa',
                                                            }}
                                                        >
                                                            <Flex gap={3} wrap>
                                                                    <Tag color="blue" style={{ fontWeight: 'bold', marginRight: 4 }}>
                                                                        Qty: {item?.quantity}
                                                                    </Tag>
                                                                    <Tag color="blue" style={{ margin: 0 }}>Remaining Qty: {item?.remaining_batch_quantity}</Tag>
                                                                    <Tag>Expiry: {item?.expiry_date ? dayjs(item?.expiry_date).format('DD-MM-YYYY') : ''}</Tag>

                                                                <Tag color='blue' style={{ fontSize: '13px', fontWeight: 500 }}>
                                                                    Code: {item?.supplier_batch_code ? item?.supplier_batch_code : 'N/A'}
                                                                </Tag>
                                                            </Flex>

                                                        </div>
                                                    </Option>
                                                );
                                            })}
                                        </Select>
                                    </Col>
                                </Row>
                                <Row >
                                    <Col >
                                        <Text>Quantity</Text>
                                        <Flex align="center" gap="small">
                                            <Input size="large" type='number' value={returnedStock?.quantity}
                                                onChange={(e) => {
                                                    const newQty = e.target.value
                                                      if (e.target.value.includes('.')) return;

                                                    if (newQty > selectedItem?.remaining_quantity_returned) return showMessage('error', 'Quantity can not be greater than remaining quantity')
                                                    if (newQty > returnedStock?.remaining_item_batch_quantity) return showMessage('error', 'Quantity can not be greater than remaining batch quantity')
                                                    if (newQty < 0) {
                                                        showMessage('error', 'Quantity cannot be negative');
                                                        return;
                                                    }
                                                    setReturnedStock({ ...returnedStock, quantity: newQty })
                                                }
                                                }
                                                style={{ width: "290px" }} placeholder="Quantity" />
                                            {
                                                returnedStock?.show_remain && (
                                                     <Checkbox
                                                checked={returnedStock?.remaining_quantity_check}
                                                style={{ fontSize: '16px' }}
                                                onChange={(e) => {
                                                    const isChecked = e.target.checked;
                                                    const qtyRemaing = selectedItem?.remaining_quantity_returned;
                                                    if (isChecked) {
                                                        if (!returnedStock?.product_id) {
                                                            showMessage('error', 'Please select a product first');
                                                            return;
                                                        }
                                                        if (!returnedStock?.batch_id) return showMessage('error', 'Select a batch First')

                                                        if (qtyRemaing > returnedStock?.remaining_item_batch_quantity) {
                                                            showMessage('error', 'Remaining quantity should be less than batch remaining quantity');
                                                            return;
                                                        } else {
                                                            setReturnedStock({ ...returnedStock, quantity: qtyRemaing, remaining_quantity_check: isChecked });
                                                        }
                                                    }
                                                    else {
                                                        setReturnedStock({ ...returnedStock, quantity: '', remaining_quantity_check: false });
                                                    }
                                                }}
                                            >
                                                Remaining Quantity
                                            </Checkbox>
                                                )
                                            }
                                            {
                                                                            returnedStock?.show_full && (
                                                                              <Checkbox
                                                                          checked={returnedStock?.full_pallet_check}
                                                                          size="large"
                                                                          style={{ fontSize: "16px" }}
                                                                          onChange={(e) => {
                                                                            const isChecked = e.target.checked;
                                                                            if (isChecked) {
                                                                               if (!returnedStock?.product_id) return showMessage('error', 'Please select a product first');
                                                                            //   if (!returnedStock?.location_id) return showMessage('error', 'Please select a location first');
                                                                              const selectedProduct = products?.find((pro) => pro?.netsuite_id == returnedStock?.product_id);
                                                                              const fullPalletQty = selectedProduct?.cases_in_pallets;
                                                                              setReturnedStock({ ...returnedStock, quantity: fullPalletQty, full_pallet_check: e.target.checked })
                                            
                                                                              // const selectedProduct = products?.find((pro) => pro?.netsuite_id == returnedStock?.product_id);
                                                                              // const qtyRemaing = selectedItem?.remaining_batch_quantity;
                                                                              // const fullPalletQty = selectedProduct?.cases_in_pallets;
                                                                              // if (fullPalletQty > qtyRemaing) {
                                                                              //   showMessage('error', 'Remaining quantity is less than pallet qunatity')
                                                                              //   return;
                                                                              // } else {
                                                                              //   setReturnedStock({ ...returnedStock, quantity: fullPalletQty, full_pallet_check: e.target.checked })
                                                                              // }
                                                                            } else {
                                                                              setReturnedStock({ ...returnedStock, quantity: '', full_pallet_check: false });
                                                                            }
                                            
                                                                          }
                                                                          }
                                                                        >
                                                                          Full Pallet
                                                                        </Checkbox>
                                                                            )
                                                                          }

                                        </Flex>


                                    </Col>
                                </Row>
                            </>
                        ) : (
                            <></>
                        )
                    }

                    {
                        selectedRoute?.route_returned_by > 0 && (
                            <Alert style={{ marginTop: 5}} type='info' message='Route returns locked'/>
                        )
                    }

                    <Divider />
                </>

                <Flex justify='end' gap={5}>
                    { selectedRoute?.route_returned_by < 1 && selectedItem?.remaining_quantity_returned > 0 && (
                        <>
                        <Button onClick={handleModalCancel}>Cancel</Button>
                        <Button type='primary' onClick={handleOkModal}>Save</Button>
                        </>
                    )
                    
                    }

                </Flex>

                {
                    stockTransactions?.length > 0 &&
                    (
                        <>
                            <h3 style={{ margin: 0 }}>Transactions</h3>
                            <Table
                                columns={transactionCol}
                                dataSource={stockTransactions}
                                pagination={false}
                                scroll={{ x: 'max-content' }}
                                rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
                            />
                        </>
                    )
                }
            </Modal>
        </div>
    )
}

export default GoodsReturnTab
